import React from "react";

/**
 * OrSeparator — purely visual separator between scope groups.
 * Shows a horizontal rule with a centered "OR" badge.
 */
const OrSeparator = () => (
  <div className="flex items-center gap-3 my-2">
    <div className="flex-1 border-t border-border" />
    <span className="text-xs font-semibold text-text-2 uppercase px-2 select-none">
      OR
    </span>
    <div className="flex-1 border-t border-border" />
  </div>
);

export default OrSeparator;
